import { Pipe, PipeTransform } from "@angular/core";

interface TagVariantOutput {
  tags: string[];
  colorClasses: string[];
}

@Pipe({
  name: "tagVariantLimit",
})
export class TagVariantLimitPipe implements PipeTransform {
  transform(tableVariant: string, limit: number): TagVariantOutput {
    if (!tableVariant || limit == null) return { tags: [], colorClasses: [] };

    const normalized = tableVariant.toLowerCase();
    const limitMap: Record<number, string> = {
      1: "NL",
      2: "PL",
      4: "FL",
    };

    const limitLabel = limitMap[limit] || "";

    if (normalized.includes("hold")) {
      return {
        tags: [`${limitLabel}H`],
        colorClasses: [this.getColorClass(limitLabel)],
      };
    }

    // Omaha
    if (normalized.includes("omaha")) {
      if (normalized.includes("3")) {
        return { tags: [`${limitLabel}O3`], colorClasses: ["orange"] };
      }
      if (normalized.includes("4")) {
        return { tags: [`${limitLabel}O4`], colorClasses: ["orange"] };
      }
      if (normalized.includes("5")) {
        return { tags: [`${limitLabel}O5`], colorClasses: ["orange"] };
      }
      if (normalized.includes("6")) {
        return { tags: [`${limitLabel}O6`], colorClasses: ["orange"] };
      }
      if (normalized.includes("7")) {
        return { tags: [`${limitLabel}O7`], colorClasses: ["orange"] };
      }
      if (normalized.includes("8")) {
        return { tags: [`${limitLabel}O8`], colorClasses: ["orange"] };
      }
      if (normalized.includes("9")) {
        return { tags: [`${limitLabel}O9`], colorClasses: ["orange"] };
      }
      return { tags: [`${limitLabel}O`], colorClasses: ["orange"] };
    }

    return {
      tags: [tableVariant, limitLabel],
      colorClasses: [this.getColorClass(limitLabel), "default"],
    };
  }

  private getColorClass(limitLabel: string): string {
    switch (limitLabel) {
      case "NL":
        return "dark-blue";
      case "PL":
        return "orange";
      case "FL":
        return "violet";
      default:
        return "default";
    }
  }
}
